export default {
  dashboard: '首页',
  personalData: '个人资料',
  sign: {
    login: '登录',
    register: '注册',
    forgetpass: '忘记密码'
  },
  performance: {
    rateAdd: '新增评级设置',
    rateModify: '编辑评级设置'
  }
}
